module.exports = __webpack_public_path__ + "img/rights.b705dc0.jpg";